export default __webpack_public_path__ + "static/media/bg-bege.7910d453.jpg";